import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'standalone_confirmation';
export const route = 'standalone/confirmation/[shoppingBasketID]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "membershipstandalonecampaignsconfirmation" */
'../../components/MembershipStandaloneCampaignsConfirmation')));